/**
 * Labstep
 *
 * @module components/Group/Action/ManagePermissions/Table
 * @desc Update workspace permissions per user
 */

import EntitySearch from 'labstep-web/components/Entity/Search';
import { BulkAction } from 'labstep-web/components/Entity/Search/BulkActions';
import { GroupCardEmptyState } from 'labstep-web/components/Group/Card/EmptyState';
import { UserTable } from 'labstep-web/components/User/Table';
import {
  Action,
  UserGroupActionMenu,
} from 'labstep-web/components/UserGroup/Action/Menu';
import { UserGroup } from 'labstep-web/models/user-group.model';
import type React from 'react';
import GroupActionAddUser from '../../AddUser';
import { GroupActionShare } from '../../Share';
import type { GroupActionManageMembersTableProps } from './types';

export const GroupActionManageMembersTable: React.FC<
  GroupActionManageMembersTableProps
> = ({ group }) => {
  const confirmMessage = `Are you sure you want to remove these members from ${group.name}?`;

  return (
    <EntitySearch
      entityName={UserGroup.entityName}
      params={{
        group_id: group.id,
      }}
      bulkActions={[
        {
          action: BulkAction.delete,
          props: {
            confirmMessage,
            header: 'Remove Members',
            confirmButtonContent: 'Remove',
            actionComponentProps: {
              type: 'button',
              icon: 'ban',
              text: 'Remove from Workspace',
            },
          },
        },
      ]}
      action={
        group.canInvite ? (
          <GroupActionShare
            actionComponentProps={{
              type: 'button',
            }}
            group={group}
          />
        ) : (
          <GroupActionAddUser group={group} />
        )
      }
      noResultsMessage={
        <GroupCardEmptyState isActionAllowed={false} />
      }
      searchBarProps={{
        placeholder: `Search ${group.name}'s members ...`,
      }}
    >
      {({ entities }) => (
        <UserTable
          userGroups={entities}
          actionMenu={({ entity }: { entity: UserGroup }) => (
            <UserGroupActionMenu
              userGroup={entity}
              actions={[Action.delete_user_group]}
            />
          )}
        />
      )}
    </EntitySearch>
  );
};
